export default __webpack_public_path__ + "static/media/gif-id-plastico.ec7e8217.gif";